import { render, staticRenderFns } from "./dalogChild.vue?vue&type=template&id=5427f858&scoped=true"
import script from "./dalogChild.vue?vue&type=script&lang=js"
export * from "./dalogChild.vue?vue&type=script&lang=js"
import style0 from "./dalogChild.vue?vue&type=style&index=0&id=5427f858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427f858",
  null
  
)

export default component.exports